import React from 'react';
import { Navbar } from 'components';
import './LayoutWithNavbar.scss';

const LayoutWithNavbar = Wrapped => props => (
  <div className="app-wrapper app-wrapper--with-navbar">

    <Navbar {...props} />

    <main className="app-wrapper__content">
      <Wrapped {...props} />
    </main>
  </div>
);

export default LayoutWithNavbar;
